import { createSlice } from '@reduxjs/toolkit';
const popupSlice = createSlice({
    name: 'popup',
    initialState: {
        guidePopup: false,
        /** Banner data từ API (banner đầu tiên active) */
        bannerData: null,
    },
    reducers: {
        closeGuide(state) {
            state.guidePopup = false;
        },
        setGuide(state, action) {
            state.guidePopup = action.payload;
        },
        setBannerData(state, action) {
            state.bannerData = action.payload;
        },
    },
});

const popupActions = popupSlice.actions;
const popupReducer = popupSlice.reducer;

export { popupActions };
export default popupReducer;
